import { useContext } from "react";
import I18n from "../libs/i18n/I18n";
import translations from "../libs/i18n/Translations";
export default function useI18n(group) {
    const { state, setState } = useContext(I18n);
    return {
        language: state.language,
        get: (key) => {
            return translations.get(group, key);
        },
        load: async (language) => {
            setState({ ...state, language, status: "pending" });
            window === null || window === void 0 ? void 0 : window.localStorage.setItem("language", language);
            try {
                await translations.load(language);
                setState({ ...state, language, status: "ok" });
            }
            catch (error) {
                console.error(error);
                setState({ ...state, language, status: "error" });
            }
        },
    };
}
